export const TOKEN_EXCHANGE_PAYLOAD = {
    grant_type: 'authorization_code',
    code: '<authorization_code_from_redirect>',
    redirect_uri: 'https://example.com/callback',
    client_id: '<your_client_id>',
    client_secret: '<your_client_secret>',
};

export const REFRESH_TOKEN_REQUEST = {
    grant_type: 'refresh_token',
    refresh_token: '<refresh_token>',
};


export const CREATE_REFERRER_PAYLOAD = {
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    mobileNumber: '+1234567890',
    address: 'New York, USA',
};

export const SEND_REFERRAL_PAYLOAD = {
    firstName: 'Jane',
    lastName: 'Doe', // optional
    email: 'jane.doe@example.com',
    mobileNumber: '+1234567890',
    comment: 'Interested in your services',
    businessEmail: 'business@example.com',
    referrerEmail: 'referrer@example.com',
    reward: 1,
};

export const UPDATE_REFERRAL_STATUS_PAYLOAD = {
    referralEmail: 'hina@yopmail.com',
    referrerEmail: 'john12@yopmail.com',
    businessEmail: 'nov19_01@yopmail.com',
    status: 'acknowledged', // acknowledged | contacted | qualified | rejected
};

export const PAY_REFERRAL_REQUEST = {
    referralEmail: 'hina@yopmail.com',
    offerId: 35,
    totalAmountPaid: 20,
};

export const PAY_REFERRER_REQUEST = {
    referrerEmail: 'jimmy@yopmail.com',
    amount: 100,
};

